class CustomCartDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-custom-cart-drawer]');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('[data-cart-overlay]');
    this.closeBtn = this.drawer.querySelector('[data-cart-close]');
    this.clearBtn = this.drawer.querySelector('[data-clear-cart]');
    this.productsContainer = this.drawer.querySelector('[data-cart-products]');
    this.trigger = document.querySelector('#HeaderCartTrigger');
    
    this.productsCache = new Map();
    this.addingFreeGift = false;

    try {
      sessionStorage.removeItem(CustomCartDrawer.FREE_GIFT_DECLINED_KEY);
    } catch (e) {}

    this.init();
  }

  init() {
    this.disableOldCart();

    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', () => this.clearCart());
    }

    this.interceptAddToCartButtons();

      document.addEventListener('ajaxProduct:added', async (e) => {
        const wasEmpty = await this.isCartEmpty();
        
        // Prepara UI se carrinho estava vazio
        if (wasEmpty) {
          const emptyState = this.productsContainer?.querySelector('.custom-cart-drawer__empty');
          if (emptyState) emptyState.style.display = 'none';

          let itemsWrapper = this.productsContainer?.querySelector('.custom-cart-drawer__items-wrapper');
          if (!itemsWrapper && this.productsContainer) {
            itemsWrapper = document.createElement('div');
            itemsWrapper.className = 'custom-cart-drawer__items-wrapper';
            this.productsContainer.appendChild(itemsWrapper);
          }

          const footer = this.drawer.querySelector('.custom-cart-drawer__footer');
          const clearSection = this.drawer.querySelector('.custom-cart-drawer__clear');
          const discountSection = this.drawer.querySelector('[data-discount-section]');
          const shippingSection = this.drawer.querySelector('[data-shipping-section]');
          if (footer) footer.classList.remove('is-hidden');
          if (clearSection) clearSection.classList.remove('is-hidden');
          if (discountSection) discountSection.classList.remove('is-hidden');
          if (shippingSection) shippingSection.classList.remove('is-hidden');
        }
        
        // Carrega e renderiza o carrinho PRIMEIRO, depois abre
        const cart = await this.loadCart();
        
        // Só abre se realmente tiver itens e conteúdo renderizado
        if (cart && cart.items && cart.items.length > 0) {
          // Garante que o DOM está totalmente atualizado antes de abrir
          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          
          this.open();
          
          const orderbumpSection = this.drawer.querySelector('[data-orderbump-section]');
          if (orderbumpSection && orderbumpSection.classList.contains('is-hidden')) {
            this.refreshOrderbump().catch(() => {});
          } else if (orderbumpSection) {
            orderbumpSection.classList.remove('is-hidden');
            requestAnimationFrame(() => this.initOrderbump());
          } else {
            this.refreshOrderbump().catch(() => {});
          }
        }
      });

    document.addEventListener('cart:open', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.open();
    });

    document.addEventListener('product:added-to-cart', () => {
      this.loadCart();
      this.open();
    });

    this.productsContainer?.addEventListener('click', (e) => {
      const minusBtn = e.target.closest('[data-qty-minus]');
      const plusBtn = e.target.closest('[data-qty-plus]');

      if (minusBtn) {
        this.updateQuantity(minusBtn.dataset.key, 'minus');
      } else if (plusBtn) {
        this.updateQuantity(plusBtn.dataset.key, 'plus');
      }
    });

    this.productsContainer?.addEventListener('change', (e) => {
      const qtyInput = e.target.closest('[data-qty-input]');
      if (qtyInput) {
        const newQty = parseInt(qtyInput.value) || 0;
        this.updateQuantity(qtyInput.dataset.key, 'set', newQty);
      }
    });

    this.productsContainer?.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.dataset.key;
        if (key) {
          this.updateQuantity(key, 'set', 0);
        }
        return;
      }
      
      // Handle discount remove no badge do item (dentro do productsContainer)
      const discountRemoveBtn = e.target.closest('[data-discount-remove]');
      if (discountRemoveBtn && discountRemoveBtn.closest('.custom-cart-item__discount-badge')) {
        e.preventDefault();
        e.stopPropagation();
        const code = (discountRemoveBtn.getAttribute('data-discount-remove') || '').trim();
        if (code) {
          console.log('[CartDrawer] Remover cupom clicado (badge), código:', code);
          this.removeDiscount(code);
        }
      }
    });

    // Remover cupom no footer (bloco "Desconto no pedido") — o X fica fora do productsContainer
    this.drawer.addEventListener('click', (e) => {
      const discountRemoveBtn = e.target.closest('[data-discount-remove]');
      if (!discountRemoveBtn || !this.drawer.contains(discountRemoveBtn)) return;
      if (discountRemoveBtn.closest('[data-cart-discounts-applied]')) {
        e.preventDefault();
        e.stopPropagation();
        const code = (discountRemoveBtn.getAttribute('data-discount-remove') || '').trim();
        if (code) {
          console.log('[CartDrawer] Remover cupom clicado (footer), código:', code);
          this.removeDiscount(code);
        }
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('is-visible')) {
        this.close();
      }
    });

    this.observeNewForms();

    this.loadCart().then(async () => {
      // After initial cart load, update discount display and initialize handlers
      await this.updateDiscountDisplay();
      this.initDiscount();
      this.initShipping();
    });

    this.initOrderbump();
    this.initDiscount();
    this.initShipping();
  }

  initOrderbump() {
    const orderbumpSection = this.drawer?.querySelector('[data-orderbump-section]');
    const carousel = orderbumpSection?.querySelector('[data-orderbump-carousel]');
    const prevBtn = orderbumpSection?.querySelector('[data-orderbump-prev]');
    const nextBtn = orderbumpSection?.querySelector('[data-orderbump-next]');
    
    const orderbumpSidebar = this.drawer?.querySelector('[data-orderbump-sidebar]');
    const sidebarCarousel = orderbumpSidebar?.querySelector('[data-orderbump-sidebar-carousel]');
    const sidebarPrevBtn = orderbumpSidebar?.querySelector('[data-orderbump-sidebar-prev]');
    const sidebarNextBtn = orderbumpSidebar?.querySelector('[data-orderbump-sidebar-next]');
    
    const addBtns = this.drawer?.querySelectorAll('[data-orderbump-add]');
    
    if (!addBtns || addBtns.length === 0) return;
    
    addBtns.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode?.replaceChild(newBtn, btn);
    });
    
    const freshAddBtns = this.drawer?.querySelectorAll('[data-orderbump-add]');
    if (!freshAddBtns || freshAddBtns.length === 0) return;

    if (prevBtn && carousel) {
      prevBtn.addEventListener('click', () => {
        const scrollAmount = carousel.clientWidth;
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (nextBtn && carousel) {
      nextBtn.addEventListener('click', () => {
        const scrollAmount = carousel.clientWidth;
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    if (carousel && prevBtn && nextBtn) {
      const updateNavButtons = () => {
        const { scrollLeft, scrollWidth, clientWidth } = carousel;
        const isAtStart = scrollLeft <= 0;
        const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;

        prevBtn.style.opacity = isAtStart ? '0.3' : '1';
        prevBtn.style.pointerEvents = isAtStart ? 'none' : 'auto';
        nextBtn.style.opacity = isAtEnd ? '0.3' : '1';
        nextBtn.style.pointerEvents = isAtEnd ? 'none' : 'auto';
      };

      carousel.addEventListener('scroll', updateNavButtons);
      updateNavButtons();
    }

    if (sidebarPrevBtn && sidebarCarousel) {
      sidebarPrevBtn.addEventListener('click', () => {
        const scrollAmount = sidebarCarousel.clientHeight * 0.8;
        sidebarCarousel.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (sidebarNextBtn && sidebarCarousel) {
      sidebarNextBtn.addEventListener('click', () => {
        const scrollAmount = sidebarCarousel.clientHeight * 0.8;
        sidebarCarousel.scrollBy({ top: scrollAmount, behavior: 'smooth' });
      });
    }

    if (sidebarCarousel && sidebarPrevBtn && sidebarNextBtn) {
      const updateNavButtons = () => {
        const { scrollTop, scrollHeight, clientHeight } = sidebarCarousel;
        const isAtStart = scrollTop <= 0;
        const isAtEnd = scrollTop + clientHeight >= scrollHeight - 1;

        sidebarPrevBtn.disabled = isAtStart;
        sidebarPrevBtn.style.opacity = isAtStart ? '0.3' : '1';
        sidebarNextBtn.disabled = isAtEnd;
        sidebarNextBtn.style.opacity = isAtEnd ? '0.3' : '1';
      };

      sidebarCarousel.addEventListener('scroll', updateNavButtons);
      updateNavButtons();
    }

    freshAddBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const productId = btn.dataset.productId;
        const variantId = btn.dataset.variantId;

        if (!productId || !variantId) return;

        const orderbumpItem = btn.closest('.custom-orderbump-item');
        
        btn.classList.add('is-loading');
        btn.disabled = true;
        const originalText = btn.innerHTML;
        btn.innerHTML = '<span>ADICIONANDO...</span>';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          const item = await response.json();
          
          if (item.description && !item.variant_id) {
            alert(item.description || 'Erro ao adicionar produto ao carrinho');
            btn.innerHTML = originalText;
            btn.classList.remove('is-loading');
            btn.disabled = false;
            return;
          }

          
          if (orderbumpItem) {
            orderbumpItem.remove();
            this.updateOrderbumpNavigation();
          }
          
          const cartPromise = this.loadCart();
          const orderbumpPromise = this.refreshOrderbump();
          
          await Promise.all([cartPromise, orderbumpPromise]);
          
          document.dispatchEvent(new CustomEvent('orderbump:added', { 
            detail: { product: item } 
          }));

          btn.innerHTML = originalText;
          btn.classList.remove('is-loading');
          btn.disabled = false;
        } catch (error) {
          alert('Erro ao adicionar produto ao carrinho');
          btn.innerHTML = originalText;
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      });
    });
  }

  updateOrderbumpNavigation() {
    const orderbumpSection = this.drawer?.querySelector('[data-orderbump-section]');
    const carousel = orderbumpSection?.querySelector('[data-orderbump-carousel]');
    const prevBtn = orderbumpSection?.querySelector('[data-orderbump-prev]');
    const nextBtn = orderbumpSection?.querySelector('[data-orderbump-next]');
    
    if (carousel && prevBtn && nextBtn) {
      const items = carousel.querySelectorAll('.custom-orderbump-item');
      const { scrollLeft, scrollWidth, clientWidth } = carousel;
      const isAtStart = scrollLeft <= 0;
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      if (items.length <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.opacity = isAtStart ? '0.3' : '1';
        prevBtn.style.pointerEvents = isAtStart ? 'none' : 'auto';
        nextBtn.style.opacity = isAtEnd ? '0.3' : '1';
        nextBtn.style.pointerEvents = isAtEnd ? 'none' : 'auto';
      }
    }

    const orderbumpSidebar = this.drawer?.querySelector('[data-orderbump-sidebar]');
    const sidebarCarousel = orderbumpSidebar?.querySelector('[data-orderbump-sidebar-carousel]');
    const sidebarPrevBtn = orderbumpSidebar?.querySelector('[data-orderbump-sidebar-prev]');
    const sidebarNextBtn = orderbumpSidebar?.querySelector('[data-orderbump-sidebar-next]');
    
    if (sidebarCarousel && sidebarPrevBtn && sidebarNextBtn) {
      const items = sidebarCarousel.querySelectorAll('.custom-orderbump-item');
      const { scrollTop, scrollHeight, clientHeight } = sidebarCarousel;
      const isAtStart = scrollTop <= 0;
      const isAtEnd = scrollTop + clientHeight >= scrollHeight - 1;

      if (items.length <= 1) {
        sidebarPrevBtn.style.display = 'none';
        sidebarNextBtn.style.display = 'none';
      } else {
        sidebarPrevBtn.disabled = isAtStart;
        sidebarPrevBtn.style.opacity = isAtStart ? '0.3' : '1';
        sidebarNextBtn.disabled = isAtEnd;
        sidebarNextBtn.style.opacity = isAtEnd ? '0.3' : '1';
      }
    }

    const allOrderbumpItems = this.drawer?.querySelectorAll('.custom-orderbump-item');
    if (allOrderbumpItems && allOrderbumpItems.length === 0) {
      if (orderbumpSection) {
        orderbumpSection.remove();
      }
      if (orderbumpSidebar) {
        orderbumpSidebar.remove();
      }
    } else {
      if (orderbumpSection && allOrderbumpItems && allOrderbumpItems.length > 0) {
        orderbumpSection.style.display = '';
      }
      if (orderbumpSidebar && allOrderbumpItems && allOrderbumpItems.length > 0) {
        orderbumpSidebar.style.display = '';
      }
    }
  }

  async refreshOrderbump() {
    try {
      const response = await fetch('/?section_id=custom-cart-drawer-orderbump');
      if (!response.ok) {
        return;
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newOrderbumpSection = doc.querySelector('[data-orderbump-section]');
      const newOrderbumpSidebar = doc.querySelector('[data-orderbump-sidebar]');
      
      const currentOrderbumpSection = this.drawer?.querySelector('[data-orderbump-section]');
      const container = this.drawer?.querySelector('.custom-cart-drawer__container');
      
      if (newOrderbumpSection) {
        if (currentOrderbumpSection) {
          currentOrderbumpSection.replaceWith(newOrderbumpSection);
        } else if (container) {
          const clearBtn = container.querySelector('.custom-cart-drawer__clear');
          if (clearBtn) {
            clearBtn.parentNode.insertBefore(newOrderbumpSection, clearBtn);
          } else {
            const footer = container.querySelector('.custom-cart-drawer__footer');
            if (footer) {
              footer.parentNode.insertBefore(newOrderbumpSection, footer);
            }
          }
        }
      } else if (currentOrderbumpSection) {
        currentOrderbumpSection.remove();
      }
      
      const currentOrderbumpSidebar = this.drawer?.querySelector('[data-orderbump-sidebar]');
      const wrapper = this.drawer?.querySelector('.custom-cart-drawer__wrapper');
      
      if (newOrderbumpSidebar) {
        if (currentOrderbumpSidebar) {
          currentOrderbumpSidebar.replaceWith(newOrderbumpSidebar);
        } else if (wrapper) {
          wrapper.insertBefore(newOrderbumpSidebar, wrapper.firstChild);
        }
      } else if (currentOrderbumpSidebar) {
        currentOrderbumpSidebar.remove();
      }
      
        setTimeout(() => {
        this.initOrderbump();
        const allOrderbumpItems = this.drawer?.querySelectorAll('.custom-orderbump-item');
        if (allOrderbumpItems && allOrderbumpItems.length === 0) {
          const remainingSection = this.drawer?.querySelector('[data-orderbump-section]');
          const remainingSidebar = this.drawer?.querySelector('[data-orderbump-sidebar]');
          if (remainingSection) remainingSection.remove();
          if (remainingSidebar) remainingSidebar.remove();
        }
      }, 100);
    } catch (error) {
    }
  }

  observeNewForms() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { 
            const forms = node.matches?.('form[action*="/cart/add"]') 
              ? [node] 
              : node.querySelectorAll?.('form[action*="/cart/add"]') || [];
            
            if (forms.length > 0) {
              forms.forEach((form) => {
                if (!form.dataset.cartIntercepted) {
                  form.dataset.cartIntercepted = 'true';
                  this.interceptForm(form);
                }
              });
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  interceptForm(form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const formData = new FormData(form);
      const addBtn = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
      
      const wasEmpty = await this.isCartEmpty();
      
      if (addBtn) {
        addBtn.classList.add('btn--loading');
        addBtn.disabled = true;
      }

        try {
          // Get current discount codes before adding to cart
          const currentCart = await fetch('/cart.js').then(r => r.json());
          const currentDiscountCodes = currentCart.discount_codes || [];
          const discountCodesArray = currentDiscountCodes.map(dc => dc.code);
          const discountParam = discountCodesArray.length > 0 ? discountCodesArray.join(',') : '';
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const item = await response.json();
            
            // Restore discount codes after adding product
            if (discountParam) {
              try {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    discount: discountParam
                  })
                });
              } catch (discountError) {
                // Silently fail - discount codes restoration failed
              }
            }
          
          if (wasEmpty) {
            const emptyState = this.productsContainer?.querySelector('.custom-cart-drawer__empty');
            if (emptyState) {
              emptyState.style.display = 'none';
            }
            
            let itemsWrapper = this.productsContainer?.querySelector('.custom-cart-drawer__items-wrapper');
            if (!itemsWrapper && this.productsContainer) {
              itemsWrapper = document.createElement('div');
              itemsWrapper.className = 'custom-cart-drawer__items-wrapper';
              this.productsContainer.appendChild(itemsWrapper);
            }
            
            const footer = this.drawer.querySelector('.custom-cart-drawer__footer');
            const clearSection = this.drawer.querySelector('.custom-cart-drawer__clear');
            const discountSection = this.drawer.querySelector('[data-discount-section]');
            const shippingSection = this.drawer.querySelector('[data-shipping-section]');
            
            if (footer) footer.classList.remove('is-hidden');
            if (clearSection) clearSection.classList.remove('is-hidden');
            if (discountSection) discountSection.classList.remove('is-hidden');
            if (shippingSection) shippingSection.classList.remove('is-hidden');
          }
          
          const cartPromise = this.loadCart();
          
          const cart = await cartPromise;
          
          this.open();
          
          const orderbumpSection = this.drawer.querySelector('[data-orderbump-section]');
          if (orderbumpSection && orderbumpSection.classList.contains('is-hidden')) {
            this.refreshOrderbump().catch(() => {});
          } else if (orderbumpSection) {
            orderbumpSection.classList.remove('is-hidden');
            requestAnimationFrame(() => this.initOrderbump());
          } else {
            this.refreshOrderbump().catch(() => {});
          }

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { 
            detail: { product: item } 
          }));
        } else {
          const error = await response.json();
          alert(error.description || 'Erro ao adicionar produto ao carrinho');
        }
      } catch (error) {
        alert('Erro ao adicionar produto ao carrinho');
      } finally {
        if (addBtn) {
          addBtn.classList.remove('btn--loading');
          addBtn.disabled = false;
        }
      }
    });
  }

  open() {
    this.drawer.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  async isCartEmpty() {
    try {
      const timestamp = new Date().getTime();
      const response = await fetch(`/cart.js?t=${timestamp}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      const cart = await response.json();
      return !cart.items || cart.items.length === 0;
    } catch (error) {
      return true;
    }
  }

  async loadCart(skipFreeGiftCheck = false) {
    try {
      const timestamp = new Date().getTime();
      const response = await fetch(`/cart.js?t=${timestamp}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      if (!response.ok) {
        throw new Error('Failed to load cart');
      }
      const cart = await response.json();

      if (!cart.items || cart.items.length === 0) {
        try {
          sessionStorage.removeItem(CustomCartDrawer.FREE_GIFT_DECLINED_KEY);
        } catch (e) {}
      }

      await this.renderCart(cart);

      requestAnimationFrame(() => {
        this.updateCartCount(cart.item_count);
      });

      if (!skipFreeGiftCheck) {
        await this.tryAddFreeGift(cart);
      }

      return cart;
    } catch (error) {
      return null;
    }
  }

  static get FREE_GIFT_DECLINED_KEY() {
    return 'custom_cart_drawer_free_gift_declined';
  }


  async tryAddFreeGift(cart) {
    const settings = window.theme?.cartDrawerSettings;

    if (!settings?.freeGiftEnable) {
      return;
    }

    if (!settings?.freeGiftVariantId || settings.freeGiftVariantId === 0) {
      return;
    }

    if (!settings?.freeGiftThresholdCents) {
      return;
    }

    if (this.addingFreeGift) {
      return;
    }

    const variantId = String(settings.freeGiftVariantId);
    try {
      const declined = typeof sessionStorage !== 'undefined' && sessionStorage.getItem(CustomCartDrawer.FREE_GIFT_DECLINED_KEY);
      if (declined === variantId) {
        return;
      }
    } catch (e) {
    }

    const threshold = parseInt(settings.freeGiftThresholdCents, 10) || 0;
    if (cart.total_price < threshold) {
      return;
    }

    const alreadyInCart = cart.items && cart.items.some(item => String(item.variant_id) === variantId);
    if (alreadyInCart) {
      return;
    }

    this.addingFreeGift = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      const result = await response.json();
      if (result.variant_id || result.id) {
        await this.loadCart(true);
      }
    } catch (error) {
    } finally {
      this.addingFreeGift = false;
    }
  }

  async renderCart(cart) {
    if (!this.productsContainer) return;

    if (!cart || !cart.items || cart.items.length === 0) {
      if (cart) {
        this.updateTotals(cart);
        this.updateShippingBar(0);
      }
      this.showEmptyCart();
      return;
    }

    const footer = this.drawer.querySelector('.custom-cart-drawer__footer');
    const clearSection = this.drawer.querySelector('.custom-cart-drawer__clear');
    const orderbumpSection = this.drawer.querySelector('[data-orderbump-section]');
    const shippingBar = this.drawer.querySelector('.custom-cart-drawer__shipping-bar');
    const discountSection = this.drawer.querySelector('[data-discount-section]');
    const shippingSection = this.drawer.querySelector('[data-shipping-section]');
    
    if (footer) {
      footer.classList.remove('is-hidden');
      footer.style.display = ''; 
      footer.style.visibility = ''; 
    }
    if (clearSection) {
      clearSection.classList.remove('is-hidden');
      clearSection.style.display = ''; 
      clearSection.style.visibility = ''; 
    }
    if (shippingBar) {
      shippingBar.classList.remove('is-hidden');
    }
    if (discountSection) {
      discountSection.classList.remove('is-hidden');
    }
    if (shippingSection) {
      shippingSection.classList.remove('is-hidden');
    }

    let itemsWrapper = this.productsContainer.querySelector('.custom-cart-drawer__items-wrapper');
    
    if (!itemsWrapper) {
      const emptyState = this.productsContainer.querySelector('.custom-cart-drawer__empty');
      if (emptyState) {
        emptyState.remove();
      }
      
      itemsWrapper = document.createElement('div');
      itemsWrapper.className = 'custom-cart-drawer__items-wrapper';
      this.productsContainer.appendChild(itemsWrapper);
    }


    const itemsWithComparePrice = await this.enrichItemsWithComparePrice(cart.items);
    
    
    let html = '';
    const itemsLength = itemsWithComparePrice.length;
    for (let i = 0; i < itemsLength; i++) {
      html += this.renderCartItem(itemsWithComparePrice[i], cart);
    }

    itemsWrapper.innerHTML = html;
    
    // Aguarda o DOM ser atualizado antes de continuar
    await new Promise(resolve => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.updateTotals(cart);
          this.updateShippingBar(cart.total_price);
          resolve();
        });
      });
    });
    
    // Update discount display and reinitialize discount handlers
    await this.updateDiscountDisplay();
    
    // Reinitialize discount and shipping to attach handlers to newly created elements
    // Only initialize if sections are visible
    if (discountSection && !discountSection.classList.contains('is-hidden')) {
      this.initDiscount();
    }
    if (shippingSection && !shippingSection.classList.contains('is-hidden')) {
      this.initShipping();
    }
    
    if (orderbumpSection && orderbumpSection.classList.contains('is-hidden')) {
      this.refreshOrderbump().catch(() => {});
    } else if (orderbumpSection) {
      orderbumpSection.classList.remove('is-hidden');
      requestAnimationFrame(() => {
        this.initOrderbump();
      });
    } else {
      this.refreshOrderbump().catch(() => {});
    }
  }

  async enrichItemsWithComparePrice(items) {
    // Extrair handles únicos dos produtos
    const productHandles = new Set();
    
    items.forEach(item => {
      const handle = item.url?.match(/\/products\/([^\/\?]+)/)?.[1];
      if (handle && item.variant_id) {
        productHandles.add(handle);
      }
    });

    // Identificar produtos que precisam ser buscados (não estão no cache)
    const handlesToFetch = Array.from(productHandles).filter(handle => !this.productsCache.has(handle));

    // Buscar apenas produtos que não estão no cache, em paralelo
    const productPromises = handlesToFetch.map(async (handle) => {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) return { handle, product: null };
        const product = await response.json();
        // Armazenar no cache
        this.productsCache.set(handle, product);
        return { handle, product };
      } catch (error) {
        return { handle, product: null };
      }
    });

    await Promise.all(productPromises);
    
    // Usar cache para todos os produtos (incluindo os já buscados)
    const productsMap = new Map();
    productHandles.forEach(handle => {
      const product = this.productsCache.get(handle);
      if (product) {
        productsMap.set(handle, product);
      }
    });

    // Enriquecer items com compare_at_price
    return items.map(item => {
      const handle = item.url?.match(/\/products\/([^\/\?]+)/)?.[1];
      const product = productsMap.get(handle);
      
      let compareAtPrice = null;
      
      // Prioridade 1: variant.compare_at_price do produto buscado
      if (product && item.variant_id) {
        const variant = product.variants.find(v => v.id === item.variant_id);
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareAtPrice = variant.compare_at_price;
        }
      }
      
      // Prioridade 2: original_price do item (fallback)
      if (!compareAtPrice && item.original_price && item.original_price > item.final_price) {
        compareAtPrice = item.original_price;
      }
      
      return {
        ...item,
        compare_at_price: compareAtPrice
      };
    });
  }

  renderCartItem(item, cart = null) {
    // Preços - prioriza compare_at_price, senão mostra original_price se houver desconto
    const hasComparePrice = item.compare_at_price && item.compare_at_price > item.final_price;
    const comparePrice = hasComparePrice ? this.formatMoney(item.compare_at_price) : '';
    
    const hasDiscount = item.original_price && item.original_price > item.final_price;
    const originalPrice = (!hasComparePrice && hasDiscount && item.original_price) 
      ? this.formatMoney(item.original_price) 
      : '';
    
    const finalPrice = this.formatMoney(item.final_price);
    
    // Get discount allocations - try multiple sources
    let discountAllocations = item.discount_allocations || 
                             item.line_level_discount_allocations || 
                             [];
    
    // If no line-level discounts but we have cart-level discounts and a price difference,
    // create a discount allocation from cart-level discounts
    if (discountAllocations.length === 0 && hasDiscount && cart) {
      const cartDiscounts = cart.discount_applications || cart.cart_level_discount_applications || [];
      if (cartDiscounts.length > 0) {
        // Calculate discount per item (approximate)
        const discountDiff = item.original_price - item.final_price;
        if (discountDiff > 0) {
          // Use the first cart-level discount as reference
          const cartDiscount = cartDiscounts[0];
          discountAllocations = [{
            discount_application: {
              title: cartDiscount.title || cartDiscount.code || 'Desconto',
              code: cartDiscount.code
            },
            amount: discountDiff
          }];
        }
      }
    }
    
    // Build discount badges HTML
    let discountBadgesHTML = '';
    if (discountAllocations.length > 0) {
      // Get cart-level discount codes to identify which discounts can be removed
      const cartDiscountCodes = cart ? (cart.discount_applications || cart.cart_level_discount_applications || []) : [];
      
      discountBadgesHTML = discountAllocations.map(discount => {
        const discountTitle = discount.discount_application?.title || 
                             discount.title || 
                             discount.discount_application?.code || 
                             discount.code || 
                             'Desconto';
        const discountAmount = discount.amount || 
                             discount.total_allocated_amount || 
                             0;
        
        if (!discountTitle || !discountAmount || discountAmount <= 0) return '';
        
        // Check if this is a cart-level discount (can be removed)
        // Cart-level discounts have type 'discount_code' or 'manual', or appear in cart.discount_applications
        const discountCode = discount.code || 
                           discount.discount_application?.code || 
                           discountTitle;
        
        // Check if this discount matches any cart-level discount
        const isCartLevel = discount.discount_application?.type === 'discount_code' || 
                          discount.discount_application?.type === 'manual' ||
                          (cartDiscountCodes.length > 0 && cartDiscountCodes.some(da => {
                            const daCode = (da.code || '').toUpperCase();
                            const daTitle = (da.title || '').toUpperCase();
                            const discountCodeUpper = discountCode.toUpperCase();
                            const discountTitleUpper = discountTitle.toUpperCase();
                            
                            return daCode === discountCodeUpper ||
                                   daTitle === discountTitleUpper ||
                                   daCode === discountTitleUpper ||
                                   daTitle === discountCodeUpper;
                          }));
        
        return `
          <div class="custom-cart-item__discount-badge">
            <span class="custom-cart-item__discount-label">${this.escapeHtml(discountTitle)}</span>
            <span class="custom-cart-item__discount-amount">-${this.formatMoney(discountAmount)}</span>
            ${isCartLevel ? `
              <button 
                type="button" 
                class="custom-cart-item__discount-remove-btn"
                data-discount-remove="${this.escapeHtml(discountCode)}"
                aria-label="Remover cupom"
              >
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                  <path d="M3.5 3.5L10.5 10.5M10.5 3.5L3.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>
            ` : ''}
          </div>
        `;
      }).filter(Boolean).join('');
    }
    
    return `
      <div class="custom-cart-item" data-cart-item data-key="${item.key}">
        <div class="custom-cart-item__image-wrapper">
          <a href="${item.url}" class="custom-cart-item__image-link">
            <img 
              class="custom-cart-item__image"
              src="${item.image}"
              alt="${this.escapeHtml(item.product_title)}"
              width="100"
              height="100"
              loading="lazy"
              decoding="async"
            >
          </a>
        </div>

        <div class="custom-cart-item__details">
          <div class="custom-cart-item__info">
            <div class="custom-cart-item__header-row">
              <a href="${item.url}" class="custom-cart-item__title">
                ${this.escapeHtml(item.product_title)}
              </a>
              <button 
                type="button" 
                class="custom-cart-item__remove-btn"
                data-remove-item
                data-key="${item.key}"
                aria-label="Remover item"
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3 5H15M6 5V3C6 2.44772 6.44772 2 7 2H11C11.5523 2 12 2.44772 12 3V5M8 8V13M10 8V13M4 5L5 15C5 15.5523 5.44772 16 6 16H12C12.5523 16 13 15.5523 13 15L14 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
            ${item.variant_title ? `
              <div class="custom-cart-item__variants">
                <span class="custom-cart-item__variant">${this.escapeHtml(item.variant_title)}</span>
              </div>
            ` : ''}
          </div>

          <div class="custom-cart-item__price-qty">
            <div class="custom-cart-item__pricing">
              ${comparePrice ? `<div class="custom-cart-item__compare-price">${comparePrice}</div>` : (originalPrice ? `<div class="custom-cart-item__original-price">${originalPrice}</div>` : '')}
              <div class="custom-cart-item__price">${finalPrice}</div>
              ${discountBadgesHTML}
            </div>

            <div class="custom-cart-item__quantity-controls">
              <button 
                type="button" 
                class="custom-cart-item__qty-btn custom-cart-item__qty-btn--minus"
                data-qty-minus
                data-key="${item.key}"
                aria-label="Diminuir quantidade"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3 7H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>

              <input 
                type="number" 
                class="custom-cart-item__qty-input"
                value="${item.quantity}"
                min="0"
                data-qty-input
                data-key="${item.key}"
                aria-label="Quantidade"
              >

              <button 
                type="button" 
                class="custom-cart-item__qty-btn custom-cart-item__qty-btn--plus"
                data-qty-plus
                data-key="${item.key}"
                aria-label="Aumentar quantidade"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M7 3V11M3 7H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  showEmptyCart() {
    if (!this.productsContainer) return;

    try {
      sessionStorage.removeItem(CustomCartDrawer.FREE_GIFT_DECLINED_KEY);
    } catch (e) {}

    const itemsWrapper = this.productsContainer.querySelector('.custom-cart-drawer__items-wrapper');
    if (itemsWrapper) {
      itemsWrapper.remove();
    }

    let emptyState = this.productsContainer.querySelector('.custom-cart-drawer__empty');
    if (emptyState) {
      emptyState.remove();
    }
    
    emptyState = document.createElement('div');
    emptyState.className = 'custom-cart-drawer__empty';
    emptyState.innerHTML = `
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <path d="M44.15 52H19.85C17.71 52 15.96 50.29 15.96 48.2V25.59H48.03V48.21C48.03 50.29 46.29 52 44.15 52Z" stroke="currentColor" stroke-width="2"/>
        <path d="M31.18 10C31.18 10 24.26 9.81 24.26 18.83C24.26 27.85 24.26 32.29 24.26 32.29" stroke="currentColor" stroke-width="2"/>
        <path d="M31.18 10C31.18 10 38.09 9.81 38.09 18.83C38.09 27.85 38.09 32.29 38.09 32.29" stroke="currentColor" stroke-width="2"/>
      </svg>
      <p>Seu carrinho está vazio</p>
      <a href="${window.theme?.routes?.collections || '/collections/all'}" class="custom-cart-drawer__continue-shopping">
        Continuar Comprando
      </a>
    `;
    this.productsContainer.appendChild(emptyState);
    
    emptyState.style.display = 'flex';

    const shippingBar = this.drawer.querySelector('.custom-cart-drawer__shipping-bar');
    if (shippingBar) {
      shippingBar.classList.add('is-hidden');
    }

    const footer = this.drawer.querySelector('.custom-cart-drawer__footer');
    const clearSection = this.drawer.querySelector('.custom-cart-drawer__clear');
    const orderbumpSection = this.drawer.querySelector('[data-orderbump-section]');
    const orderbumpSidebar = this.drawer.querySelector('[data-orderbump-sidebar]');
    
    const discountSection = this.drawer.querySelector('[data-discount-section]');
    const shippingSection = this.drawer.querySelector('[data-shipping-section]');
    
    if (footer) {
      footer.classList.add('is-hidden');
      footer.style.display = 'none'; 
      footer.style.visibility = 'hidden'; 
    }
    if (clearSection) {
      clearSection.classList.add('is-hidden');
      clearSection.style.display = 'none'; 
      clearSection.style.visibility = 'hidden'; 
    }
    if (discountSection) {
      discountSection.classList.add('is-hidden');
    }
    if (shippingSection) {
      shippingSection.classList.add('is-hidden');
    }
    
    if (orderbumpSection) {
      orderbumpSection.remove();
    }
    if (orderbumpSidebar) {
      orderbumpSidebar.remove();
    }
  }

  async updateQuantity(key, action, newQty = null) {
    const cartItem = this.productsContainer.querySelector(`[data-key="${key}"]`);
    const qtyControls = cartItem?.querySelector('.custom-cart-item__quantity-controls');
    
    if (qtyControls) {
      qtyControls.classList.add('is-loading');
    }

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const item = cart.items.find(i => i.key === key);
      if (!item) return;

      let quantity = item.quantity;
      
      if (action === 'minus') {
        quantity = Math.max(0, quantity - 1);
      } else if (action === 'plus') {
        quantity = quantity + 1;
      } else if (action === 'set') {
        quantity = Math.max(0, newQty);
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });

      const updatedCart = await response.json();
      if (quantity === 0) {
        const freeGiftVariantId = window.theme?.cartDrawerSettings?.freeGiftVariantId;
        if (freeGiftVariantId && String(item.variant_id) === String(freeGiftVariantId)) {
          try {
            sessionStorage.setItem(CustomCartDrawer.FREE_GIFT_DECLINED_KEY, String(freeGiftVariantId));
          } catch (e) {}
        }
      }
      this.renderCart(updatedCart);
      this.updateCartCount(updatedCart.item_count);
      await this.tryAddFreeGift(updatedCart);

    } catch (error) {
      if (qtyControls) {
        qtyControls.classList.remove('is-loading');
      }
      this.loadCart(); 
    }
  }

  async clearCart() {
    try {
      try {
        sessionStorage.removeItem(CustomCartDrawer.FREE_GIFT_DECLINED_KEY);
      } catch (e) {}
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const cart = await response.json();
      
      this.updateTotals(cart);
      this.updateShippingBar(0);
      this.updateCartCount(0);
      
      this.showEmptyCart();
    } catch (error) {
    }
  }

  updateTotals(cart) {
    const subtotalElement = this.drawer.querySelector('[data-cart-subtotal]');
    const totalElement = this.drawer.querySelector('[data-cart-total]');
    const discountsAppliedContainer = this.drawer.querySelector('[data-cart-discounts-applied]');
    const totalPixElement = this.drawer.querySelector('[data-cart-total-pix]');
    const installmentElement = this.drawer.querySelector('.custom-cart-drawer__installment-info');

    // Subtotal = valor dos itens antes do cupom
    if (subtotalElement) {
      let subtotal = cart.items_subtotal_price;
      if (subtotal == null && cart.items && cart.items.length > 0) {
        subtotal = cart.items.reduce((sum, item) => {
          return sum + (item.original_line_price || item.line_price || item.final_line_price || 0);
        }, 0);
      }
      if (subtotal != null) {
        subtotalElement.textContent = this.formatMoney(subtotal);
      }
    }

    // Desconto no pedido: tag (ícone + código + x) com valor à direita
    if (discountsAppliedContainer) {
      const discountList = cart.discount_applications || cart.cart_level_discount_applications || [];
      if (discountList.length > 0) {
        discountsAppliedContainer.classList.remove('is-hidden');
        const tagIconSvg = '<svg class="custom-cart-drawer__order-discount-tag-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
        const xSvg = '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3.5 3.5L10.5 10.5M10.5 3.5L3.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        const rowsHtml = discountList.map(d => {
          const code = (d.code || d.title || 'Cupom').trim();
          const amount = d.total_allocated_amount != null ? d.total_allocated_amount : 0;
          const tagHtml = `<span class="custom-cart-drawer__order-discount-tag">${tagIconSvg}<span class="custom-cart-drawer__order-discount-tag-code">${this.escapeHtml(code)}</span><button type="button" class="custom-cart-drawer__order-discount-tag-remove" data-discount-remove="${this.escapeHtml(code)}" aria-label="Remover cupom ${this.escapeHtml(code)}">${xSvg}</button></span>`;
          return `<div class="custom-cart-drawer__order-discount-row"><span class="custom-cart-drawer__order-discount-label-tag"><span class="custom-cart-drawer__order-discount-label">CUPOM</span>${tagHtml}</span><span class="custom-cart-drawer__order-discount-amount">-${this.formatMoney(amount)}</span></div>`;
        }).join('');
        discountsAppliedContainer.innerHTML = rowsHtml;
      } else {
        discountsAppliedContainer.classList.add('is-hidden');
        discountsAppliedContainer.innerHTML = '';
      }
    }

    // Total = valor final após cupom
    if (totalElement && cart.total_price != null) {
      totalElement.textContent = this.formatMoney(cart.total_price);
    }

    // Update PIX total
    if (totalPixElement) {
      const pixDiscount = window.theme?.cartDrawerSettings?.pixDiscount || 5;
      const pixMultiplier = 1 - (pixDiscount / 100);
      const pixTotal = cart.total_price * pixMultiplier;
      totalPixElement.textContent = this.formatMoney(pixTotal);
    }

    // Update installment info
    if (installmentElement) {
      const installments = window.theme?.cartDrawerSettings?.installments || 12;
      const installmentValue = this.formatMoney(cart.total_price / installments);
      installmentElement.innerHTML = `parcelado em até <strong>${installments}x sem juros</strong> de <strong>${installmentValue}</strong>`;
    }

    if (cart.items.length === 0) {
      const footer = this.drawer.querySelector('.custom-cart-drawer__footer');
      const clearSection = this.drawer.querySelector('.custom-cart-drawer__clear');
      const orderbumpSection = this.drawer.querySelector('[data-orderbump-section]');
      
      const discountSection = this.drawer.querySelector('[data-discount-section]');
      const shippingSection = this.drawer.querySelector('[data-shipping-section]');
      
      if (footer) footer.classList.add('is-hidden');
      if (clearSection) clearSection.classList.add('is-hidden');
      if (orderbumpSection) orderbumpSection.classList.add('is-hidden');
      if (discountSection) discountSection.classList.add('is-hidden');
      if (shippingSection) shippingSection.classList.add('is-hidden');
    }
  }

  updateShippingBar(totalPrice) {
    const progressBarEnable = window.theme?.cartDrawerSettings?.progressBarEnable !== false;
    if (!progressBarEnable) return;

    const checkpoints = window.theme?.cartDrawerSettings?.checkpoints || [];
    if (checkpoints.length === 0) return;

    const progressFill = this.drawer.querySelector('.custom-cart-drawer__progress-fill');
    const badges = this.drawer.querySelectorAll('.custom-cart-drawer__checkpoint-badge');
    const shippingText = this.drawer.querySelector('.custom-cart-drawer__shipping-text');

    let currentCheckpoint = checkpoints[0];
    let previousCheckpointValue = 0;
    let checkpointIndex = 0;
    
    for (let i = 0; i < checkpoints.length; i++) {
      if (totalPrice < checkpoints[i].value) {
        currentCheckpoint = checkpoints[i];
        previousCheckpointValue = i > 0 ? checkpoints[i - 1].value : 0;
        checkpointIndex = i;
        break;
      } else if (i === checkpoints.length - 1) {
        currentCheckpoint = checkpoints[i];
        previousCheckpointValue = i > 0 ? checkpoints[i - 1].value : 0;
        checkpointIndex = i;
      }
    }

    const range = currentCheckpoint.value - previousCheckpointValue;
    const progressInRange = totalPrice - previousCheckpointValue;
    const progress = Math.min(100, Math.max(0, (progressInRange / range) * 100));

    const allAchieved = totalPrice >= checkpoints[checkpoints.length - 1].value;
    const hasCheckpoint = totalPrice >= currentCheckpoint.value;
    const remaining = currentCheckpoint.value - totalPrice;

    if (progressFill) {
      progressFill.style.width = `${progress}%`;
    }

    const badgesLength = badges.length;
    for (let i = 0; i < badgesLength; i++) {
      const badge = badges[i];
      const checkpointValue = checkpoints[i]?.value || 0;
      
      badge.classList.remove('is-active', 'is-achieved');
      
      if (totalPrice >= checkpointValue) {
        badge.classList.add('is-achieved');
      } else if (i === checkpointIndex) {
        badge.classList.add('is-active');
      }
    }

    if (shippingText) {
      if (allAchieved) {
        shippingText.textContent = '🎉 Você desbloqueou todos os benefícios!';
      } else if (hasCheckpoint) {
        shippingText.textContent = '✅ ' + currentCheckpoint.messageAchieved;
      } else {
        shippingText.innerHTML = currentCheckpoint.messageProgress.replace('[remaining]', `<strong>${this.formatMoney(remaining)}</strong>`);
      }
    }
  }

  updateCartCount(count) {
    const bubble = document.querySelector('.cart-link__bubble-num');
    const bubbleContainer = document.querySelector('.cart-link__bubble');
    
    if (bubble) {
      bubble.textContent = count;
    }

    if (bubbleContainer) {
      if (count > 0) {
        bubbleContainer.classList.add('cart-link__bubble--visible');
      } else {
        bubbleContainer.classList.remove('cart-link__bubble--visible');
      }
    }
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return `R$ ${value}`;
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
  }

  disableOldCart() {
    if (window.theme && window.theme.settings) {
      window.theme.settings.cartType = 'page';
    }

    const oldCart = document.querySelector('#HeaderCart');
    if (oldCart) {
      oldCart.style.display = 'none';
    }

    if (window.theme && window.theme.HeaderCart) {
      const originalHeaderCart = window.theme.HeaderCart;
      window.theme.HeaderCart = function() {
        return { 
          init: () => {},
          open: () => {},
          close: () => {}
        };
      };
    }

    const oldTriggers = document.querySelectorAll('.js-quick-add-btn, [data-add-to-cart]');
    oldTriggers.forEach(trigger => {
      const clone = trigger.cloneNode(true);
      trigger.parentNode?.replaceChild(clone, trigger);
    });
  }

  interceptAddToCartButtons() {
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    productForms.forEach((form) => {
      if (!form.dataset.cartIntercepted) {
        form.dataset.cartIntercepted = 'true';
        this.interceptForm(form);
      }
    });
  }

  initDiscount() {
    const discountSection = this.drawer?.querySelector('[data-discount-section]');
    if (!discountSection) return;

    const toggle = discountSection.querySelector('[data-discount-toggle]');
    const content = discountSection.querySelector('[data-discount-content]');
    const input = discountSection.querySelector('[data-discount-input]');
    const applyBtn = discountSection.querySelector('[data-discount-apply]');
    const message = discountSection.querySelector('[data-discount-message]');

    // Toggle accordion
    if (toggle && content) {
      // Check if handler already attached
      if (!toggle.dataset.handlerAttached) {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', !isExpanded);
          content.classList.toggle('is-open');
        });
        toggle.dataset.handlerAttached = 'true';
      }
    }

    // Apply discount
    if (applyBtn && input) {
      // Remove existing listener if any - prevent multiple handlers
      if (applyBtn.dataset.handlerAttached) {
        return; // Handler already attached
      }
      
      const handleApply = async () => {
        // Get code exactly as user typed it (preserve case)
        const code = input.value.trim();
        if (!code) {
          this.showDiscountMessage(message, 'Por favor, digite um código de desconto', 'error');
          return;
        }

        // Prevent multiple simultaneous requests
        if (applyBtn.disabled) {
          return;
        }

        applyBtn.disabled = true;
        applyBtn.textContent = 'Aplicando...';
        this.showDiscountMessage(message, '', '');

        try {

          const currentCart = await fetch('/cart.js').then(r => r.json());
          const currentDiscountCodes = currentCart.discount_codes || [];
          const previousCodes = currentDiscountCodes.map(dc => dc.code).filter(Boolean);
          
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              discount: code
            })
          });

          let updatedCart;
          try {
            updatedCart = await response.json();
          } catch (jsonError) {
            throw new Error('Invalid response from server');
          }

          if (updatedCart.errors) {
            let codesRestored = false;
            if (previousCodes.length > 0) {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  discount: previousCodes.join(',')
                })
              });
              codesRestored = true;
            }
            
            const errorMsg = updatedCart.errors.discount_codes?.[0] || 
                           updatedCart.errors.message || 
                           'Erro ao aplicar cupom. Verifique se o código está correto.';
            this.showDiscountMessage(message, errorMsg, 'error');
            // Only reload cart if we restored previous codes
            if (codesRestored) {
              await this.loadCart();
            }
            applyBtn.disabled = false;
            applyBtn.textContent = 'Aplicar';
            return;
          }
          
          // CRITICAL: Check if the code was actually applied
          // Shopify may add the code to discount_codes but mark it as "applicable: false"
          // We need to check both: if array is empty OR if code exists but is not applicable
          const codeInResponse = updatedCart.discount_codes?.find(dc => {
            const dcCode = dc.code || '';
            return dcCode === code || dcCode.toUpperCase() === code.toUpperCase();
          });
          
          const codeIsNotApplicable = codeInResponse && codeInResponse.applicable === false;
          const discountCodesEmpty = updatedCart.discount_codes && Array.isArray(updatedCart.discount_codes) && updatedCart.discount_codes.length === 0;
          
          // If code is not applicable OR array is empty, the code was rejected
          if (codeIsNotApplicable || discountCodesEmpty) {
            let codesRestored = false;
            if (previousCodes.length > 0) {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  discount: previousCodes.join(',')
                })
              });
              codesRestored = true;
            }
            
            // Check if there are automatic discounts that might conflict
            const hasAutomaticDiscounts = updatedCart.cart_level_discount_applications && 
                                        updatedCart.cart_level_discount_applications.length > 0;
            
            let errorMsg = 'Código de desconto inválido, expirado ou não aplicável ao carrinho atual';
            if (hasAutomaticDiscounts) {
              errorMsg = 'Este cupom não pode ser aplicado. Verifique se o código está correto ou se há conflito com descontos automáticos.';
            }
            
            // Code was rejected - show error immediately
            // Only reload cart if we restored previous codes (cart state changed)
            this.showDiscountMessage(message, errorMsg, 'error');
            if (codesRestored) {
              await this.loadCart();
            }
            applyBtn.disabled = false;
            applyBtn.textContent = 'Aplicar';
            return;
          }

          if (response.ok && updatedCart) {

            const immediateDiscountCodes = updatedCart.discount_codes || [];
            
            const hasNonApplicableCode = immediateDiscountCodes.some(dc => {
              const dcCode = dc.code || '';
              const matchesCode = dcCode === code || dcCode.toUpperCase() === code.toUpperCase();
              return matchesCode && dc.applicable === false;
            });
            
            if (immediateDiscountCodes.length === 0 || hasNonApplicableCode) {
              let codesRestored = false;
              if (previousCodes.length > 0) {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    discount: previousCodes.join(',')
                  })
                });
                codesRestored = true;
              }
              this.showDiscountMessage(message, 'Código de desconto inválido ou não aplicável ao carrinho atual', 'error');
              // Only reload cart if we restored previous codes
              if (codesRestored) {
                await this.loadCart();
              }
              applyBtn.disabled = false;
              applyBtn.textContent = 'Aplicar';
              return;
            }
            
            const immediateCodeFound = immediateDiscountCodes.some(dc => {
              const dcCode = dc.code || '';
              const isApplicable = dc.applicable !== false; // Check if code is applicable
              // Try exact match first, then case-insensitive
              const matches = (dcCode === code || dcCode.toUpperCase() === code.toUpperCase()) && isApplicable;
              return matches;
            });
            
            const immediateDiscountApplications = [
              ...(updatedCart.discount_applications || []),
              ...(updatedCart.cart_level_discount_applications || [])
            ];
            
            const immediateCodeInApplications = immediateDiscountApplications.some(da => {
              const appCode = da.code || '';
              const appTitle = da.title || '';
              // Try exact match first, then case-insensitive
              return appCode === code || appTitle === code ||
                     appCode.toUpperCase() === code.toUpperCase() || 
                     appTitle.toUpperCase() === code.toUpperCase();
            });
            
            // If found immediately, verify it's actually the code we sent (not just any code)
            // Only accept if the code we sent is actually in the response
            const codeActuallyApplied = immediateCodeFound || 
              (immediateCodeInApplications && immediateDiscountApplications.some(da => {
                const appCode = (da.code || '').toUpperCase();
                const appTitle = (da.title || '').toUpperCase();
                const inputCode = code.toUpperCase();
                return appCode === inputCode || appTitle === inputCode;
              }));
            
            if (codeActuallyApplied) {
              input.value = '';
              this.showDiscountMessage(message, 'Cupom aplicado com sucesso!', 'success');
              
              await this.loadCart();
              await this.updateDiscountDisplay();
              return;
            }
            
            // Wait a moment for Shopify to process the discount
            await new Promise(resolve => setTimeout(resolve, 800));
            
            // Fetch cart again to verify discount was actually applied
            const verifyResponse = await fetch('/cart.js');
            const verifiedCart = await verifyResponse.json();
            
            // Check if the discount code appears in discount_applications
            // This is the most reliable way to verify the discount was actually applied
            const allDiscountApplications = [
              ...(verifiedCart.discount_applications || []),
              ...(verifiedCart.cart_level_discount_applications || [])
            ];
            
            // Check if our code matches any application
            const codeMatchesApplication = allDiscountApplications.some(da => {
              const appCode = (da.code || '').toUpperCase();
              const appTitle = (da.title || '').toUpperCase();
              const inputCode = code.toUpperCase();
              const matches = appCode === inputCode || appTitle === inputCode || 
                     appCode.includes(inputCode) || appTitle.includes(inputCode);
              return matches;
            });
            
            // Also check if code is in discount_codes array
            const codeInDiscountCodes = verifiedCart.discount_codes?.some(dc => {
              const dcCode = dc.code || '';
              const isApplicable = dc.applicable !== false; // Check if code is applicable
              
              // Exact match first
              if (dcCode === code && isApplicable) return true;
              // Then case-insensitive
              const matches = dcCode.toUpperCase() === code.toUpperCase() && isApplicable;
              return matches;
            });
            
            // CRITICAL: Only accept if the code we sent is actually in the response
            // Verify that the code matches what we sent (not just any code)
            const verifiedCodeMatches = codeMatchesApplication && allDiscountApplications.some(da => {
              const appCode = (da.code || '').toUpperCase();
              const appTitle = (da.title || '').toUpperCase();
              const inputCode = code.toUpperCase();
              return appCode === inputCode || appTitle === inputCode;
            });
            
            const verifiedCodeInCodes = codeInDiscountCodes && verifiedCart.discount_codes?.some(dc => {
              const dcCode = (dc.code || '').toUpperCase();
              const inputCode = code.toUpperCase();
              return dcCode === inputCode;
            });
            
            // Accept if code appears in discount_applications OR if it's in discount_codes
            // But ONLY if it matches the code we actually sent
            if (verifiedCodeMatches || verifiedCodeInCodes) {
              // Success - discount was actually applied and is valid
              input.value = '';
              this.showDiscountMessage(message, 'Cupom aplicado com sucesso!', 'success');
              
              // Reload cart to get updated prices and discounts
              await this.loadCart();
              
              // Update discount display
              await this.updateDiscountDisplay();
              
            } else {
              // Code was not actually applied - restore previous codes
              if (previousCodes.length > 0) {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    discount: previousCodes.join(',')
                  })
                });
              }
              
              // Continue to final check
              // Code is not in discount_codes or discount_applications
              // Try one more time after a longer wait - Shopify might be processing
              await new Promise(resolve => setTimeout(resolve, 1000));
              
              const finalVerifyResponse = await fetch('/cart.js');
              const finalCart = await finalVerifyResponse.json();
              
              const finalCodeInDiscountCodes = finalCart.discount_codes?.some(dc => {
                const dcCode = dc.code || '';
                const isApplicable = dc.applicable !== false; // Check if code is applicable
                return dcCode && dcCode.toUpperCase() === code.toUpperCase() && isApplicable;
              });
              
              const finalAllDiscountApplications = [
                ...(finalCart.discount_applications || []),
                ...(finalCart.cart_level_discount_applications || [])
              ];
              
              const finalCodeMatchesApplication = finalAllDiscountApplications.some(da => {
                const appCode = da.code || '';
                const appTitle = da.title || '';
                // Exact match first
                if (appCode === code || appTitle === code) return true;
                // Then case-insensitive
                return appCode.toUpperCase() === code.toUpperCase() || 
                       appTitle.toUpperCase() === code.toUpperCase();
              });
              
              // Verify that the final code matches what we sent
              const finalVerifiedCodeMatches = finalCodeMatchesApplication && finalAllDiscountApplications.some(da => {
                const appCode = (da.code || '').toUpperCase();
                const appTitle = (da.title || '').toUpperCase();
                const inputCode = code.toUpperCase();
                return appCode === inputCode || appTitle === inputCode;
              });
              
              const finalVerifiedCodeInCodes = finalCodeInDiscountCodes && finalCart.discount_codes?.some(dc => {
                const dcCode = (dc.code || '').toUpperCase();
                const inputCode = code.toUpperCase();
                return dcCode === inputCode;
              });
              
              if (finalVerifiedCodeMatches || finalVerifiedCodeInCodes) {
                // Success - discount was applied after longer wait
                input.value = '';
                this.showDiscountMessage(message, 'Cupom aplicado com sucesso!', 'success');
                
                await this.loadCart();
                await this.updateDiscountDisplay();
              } else {
                // Discount code was not actually applied - it's invalid
                // Restore previous codes if they existed
                let codesRestored = false;
                if (previousCodes.length > 0) {
                  await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      discount: previousCodes.join(',')
                    })
                  });
                  codesRestored = true;
                } else {
                  // No previous codes - just remove the invalid one
                  await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      discount: ''
                    })
                  });
                  codesRestored = true; // Cart state changed (removed invalid code)
                }
                
                this.showDiscountMessage(message, 'Código de desconto inválido ou expirado', 'error');
                
                // Only reload cart if we actually changed something
                if (codesRestored) {
                  await this.loadCart();
                  await this.updateDiscountDisplay();
                }
              }
            }
          } else {
            // HTTP error - handle 409 Conflict and other errors
            // Restore previous codes if they existed
            let codesRestored = false;
            if (previousCodes.length > 0) {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  discount: previousCodes.join(',')
                })
              });
              codesRestored = true;
            }
            
            let errorMsg = 'Erro ao aplicar cupom. Tente novamente.';
            
            if (response.status === 409) {
              errorMsg = 'O carrinho está sendo atualizado. Aguarde um momento e tente novamente.';
            } else if (updatedCart) {
              errorMsg = updatedCart.description || updatedCart.message || errorMsg;
            }
            
            this.showDiscountMessage(message, errorMsg, 'error');
            
            // Only reload cart if we restored previous codes
            if (codesRestored) {
              await this.loadCart();
              await this.updateDiscountDisplay();
            }
          }
        } catch (error) {
          // Restore previous codes if they existed
          let codesRestored = false;
          if (previousCodes && previousCodes.length > 0) {
            try {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  discount: previousCodes.join(',')
                })
              });
              codesRestored = true;
            } catch (restoreError) {
              // Silently fail - discount codes restoration failed
            }
          }
          
          this.showDiscountMessage(message, 'Erro ao aplicar cupom. Tente novamente.', 'error');
          
          // Only reload cart if we restored previous codes
          if (codesRestored) {
            await this.loadCart();
            await this.updateDiscountDisplay();
          }
        } finally {
          applyBtn.disabled = false;
          applyBtn.textContent = 'Aplicar';
        }
      };

      applyBtn.addEventListener('click', handleApply);
      applyBtn.dataset.handlerAttached = 'true';
      
      // Apply on Enter key
      input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleApply();
        }
      });
    }

    // Remove discount handlers are now attached to product badges via productsContainer event listener
  }

  initShipping() {
    const shippingSection = this.drawer?.querySelector('[data-shipping-section]');
    if (!shippingSection) return;

    const toggle = shippingSection.querySelector('[data-shipping-toggle]');
    const modal = this.drawer?.querySelector('[data-shipping-modal]');
    const modalOverlay = modal?.querySelector('[data-shipping-modal-overlay]');
    const modalClose = modal?.querySelector('[data-shipping-modal-close]');
    const content = modal?.querySelector('[data-shipping-content]');
    const countrySelect = modal?.querySelector('[data-shipping-country]');
    const provinceContainer = modal?.querySelector('#ShippingProvinceContainer');
    const provinceSelect = modal?.querySelector('[data-shipping-province]');
    const zipInput = modal?.querySelector('[data-shipping-zip]');
    const calcBtn = modal?.querySelector('[data-shipping-calc]');
    const message = modal?.querySelector('[data-shipping-message]');
    const ratesContainer = modal?.querySelector('[data-shipping-rates]');

    // Open modal
    const openModal = () => {
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    };

    // Close modal
    const closeModal = () => {
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    };

    // Toggle button - open modal
    if (toggle) {
      if (!toggle.dataset.handlerAttached) {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        });
        toggle.dataset.handlerAttached = 'true';
      }
    }

    // Close button
    if (modalClose) {
      modalClose.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    // Overlay click - close modal
    if (modalOverlay) {
      modalOverlay.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    // ESC key - close modal
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal?.classList.contains('is-open')) {
        closeModal();
      }
    });

    // Handle country change - update provinces
    if (countrySelect) {
      // Load provinces for default country on init
      const defaultCountry = countrySelect.value;
      if (defaultCountry && defaultCountry !== '---') {
        this.updateShippingProvinces(defaultCountry, provinceContainer, provinceSelect);
      }

      if (!countrySelect.dataset.handlerAttached) {
        countrySelect.addEventListener('change', async (e) => {
          const countryCode = e.target.value;
          await this.updateShippingProvinces(countryCode, provinceContainer, provinceSelect);
        });
        countrySelect.dataset.handlerAttached = 'true';
      }
    }

    // Calculate shipping
    if (calcBtn) {
      if (!calcBtn.dataset.handlerAttached) {
        const handleCalculate = async () => {
          const country = countrySelect?.value;
          const province = provinceSelect?.value;
          const zip = zipInput?.value?.trim();

          if (!country || country === '---') {
            this.showShippingMessage(message, 'Por favor, selecione um país', 'error');
            return;
          }

          if (!zip) {
            this.showShippingMessage(message, 'Por favor, digite o código postal', 'error');
            return;
          }

          calcBtn.disabled = true;
          const btnText = calcBtn.querySelector('span');
          if (btnText) btnText.textContent = 'Calculando...';
          this.showShippingMessage(message, '', '');

          try {
            // Build URL with shipping address parameters
            // Shopify AJAX Cart API: GET /cart/shipping_rates.json
            // Parameters: shipping_address[zip], shipping_address[country], shipping_address[province]
            const params = new URLSearchParams();
            params.append('shipping_address[zip]', zip);
            params.append('shipping_address[country]', country);
            
            if (province && province !== '---') {
              params.append('shipping_address[province]', province);
            }

            // Use /cart/shipping_rates.json (locale is optional, defaults to store locale)
            const url = `/cart/shipping_rates.json?${params.toString()}`;
            
            const response = await fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              }
            });

            // Check response status
            if (!response.ok) {
              let errorText = '';
              try {
                errorText = await response.text();
                const errorData = JSON.parse(errorText);
                throw new Error(errorData.message || errorData.error || `Erro HTTP ${response.status}`);
              } catch (parseError) {
                throw new Error(errorText || `Erro ao calcular frete (${response.status})`);
              }
            }

            const data = await response.json();

            // Check if response has shipping_rates array
            // Response format: { "shipping_rates": [{ "name": "...", "price": "8.00", ... }] }
            if (data && data.shipping_rates && Array.isArray(data.shipping_rates) && data.shipping_rates.length > 0) {
              this.displayShippingRates(ratesContainer, data.shipping_rates);
              this.showShippingMessage(message, '', '');
            } else if (data && data.shipping_rates && Array.isArray(data.shipping_rates) && data.shipping_rates.length === 0) {
              this.showShippingMessage(message, 'Nenhuma opção de frete disponível para este endereço', 'error');
              ratesContainer.innerHTML = '';
            } else if (data && data.errors) {
              // Shopify returned errors
              const errorMsg = Array.isArray(data.errors) 
                ? data.errors.join(', ') 
                : (data.errors.message || 'Erro ao calcular frete. Verifique os dados e tente novamente.');
              this.showShippingMessage(message, errorMsg, 'error');
              ratesContainer.innerHTML = '';
            } else {
              // Unexpected response format - log for debugging
              this.showShippingMessage(message, 'Erro ao calcular frete. Verifique os dados e tente novamente.', 'error');
              ratesContainer.innerHTML = '';
            }
          } catch (error) {
            const errorMsg = error.message || 'Erro ao calcular frete. Tente novamente.';
            this.showShippingMessage(message, errorMsg, 'error');
            ratesContainer.innerHTML = '';
          } finally {
            calcBtn.disabled = false;
            if (btnText) btnText.textContent = 'Calcular as taxas de envio';
          }
        };

        calcBtn.addEventListener('click', handleCalculate);
        calcBtn.dataset.handlerAttached = 'true';

        // Calculate on Enter key in zip input
        if (zipInput) {
          zipInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleCalculate();
            }
          });
        }
      }
    }

    // Cancel button - close accordion
  }

  async updateShippingProvinces(countryCode, provinceContainer, provinceSelect) {
    if (!provinceContainer || !provinceSelect) return;

    // Find the country option to get provinces data
    const countryOption = document.querySelector(`[data-shipping-country] option[value="${countryCode}"]`);
    if (!countryOption) {
      provinceContainer.style.display = 'none';
      return;
    }

    const provincesData = countryOption.getAttribute('data-provinces');
    if (!provincesData || provincesData === '[]') {
      provinceContainer.style.display = 'none';
      return;
    }

    try {
      const provinces = JSON.parse(provincesData.replace(/&quot;/g, '"'));
      provinceSelect.innerHTML = '';

      provinces.forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        provinceSelect.appendChild(option);
      });

      provinceContainer.style.display = '';
    } catch (error) {
      provinceContainer.style.display = 'none';
    }
  }

  displayShippingRates(container, rates) {
    if (!container) return;

    if (rates.length === 0) {
      container.innerHTML = '<p class="custom-cart-shipping__no-rates">Nenhuma opção de frete disponível</p>';
      return;
    }

    let html = '<div class="custom-cart-shipping__rates-list">';
    rates.forEach(rate => {
      // Handle different rate formats - price can be:
      // - String: "8.00" (Shopify AJAX API format)
      // - Number: 800 (cents)
      // - Object: { amount: 800 }
      let priceValue = rate.price;
      
      if (typeof priceValue === 'string') {
        // Convert "8.00" to cents (800)
        priceValue = Math.round(parseFloat(priceValue) * 100);
      } else if (typeof priceValue === 'object' && priceValue !== null) {
        priceValue = priceValue.amount || priceValue.price || 0;
      } else if (typeof priceValue === 'number') {
        // Already in cents or dollars? Check if it's reasonable
        // If price is less than 100, assume it's in dollars, convert to cents
        if (priceValue < 100 && priceValue > 0) {
          priceValue = Math.round(priceValue * 100);
        }
      }
      
      const price = this.formatMoney(priceValue);
      
      // Handle different name/title formats
      const rateName = rate.name || rate.title || 'Frete';
      const deliveryRange = rate.delivery_range || rate.delivery_time || rate.delivery_date || '';
      
      html += `
        <div class="custom-cart-shipping__rate-item">
          <div class="custom-cart-shipping__rate-info">
            <span class="custom-cart-shipping__rate-name">${this.escapeHtml(rateName)}</span>
            ${deliveryRange ? `<span class="custom-cart-shipping__rate-delivery">${this.escapeHtml(String(deliveryRange))}</span>` : ''}
          </div>
          <span class="custom-cart-shipping__rate-price">${price}</span>
        </div>
      `;
    });
    html += '</div>';

    container.innerHTML = html;
  }

  showShippingMessage(element, text, type) {
    if (!element) return;
    
    element.textContent = text;
    element.className = 'custom-cart-shipping__message';
    if (type) {
      element.classList.add(`is-${type}`);
    }
  }

  showDiscountMessage(element, text, type) {
    if (!element) return;
    
    element.textContent = text;
    element.className = 'custom-cart-discount__message';
    if (type) {
      element.classList.add(`is-${type}`);
    }
  }

  async removeDiscount(code) {
    const PREFIX = '[CartDrawer]';
    if (!code || typeof code !== 'string') {
      console.warn(PREFIX, 'removeDiscount: código inválido', code);
      return;
    }
    const codeTrimmed = code.trim();
    if (!codeTrimmed) {
      console.warn(PREFIX, 'removeDiscount: código vazio após trim');
      return;
    }

    try {
      console.log(PREFIX, 'removeDiscount: buscando carrinho atual...');
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      const cart = await cartRes.json();
      const currentCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const applications = cart.discount_applications || cart.cart_level_discount_applications || [];

      console.log(PREFIX, 'removeDiscount: cart.discount_codes', currentCodes);
      console.log(PREFIX, 'removeDiscount: discount_applications', applications);

      // Código exato para remover: o que está em discount_codes ou o que veio do botão
      const normalize = (s) => (s || '').toUpperCase().trim();
      let codeToRemoveValue = codeTrimmed;
      const matchInCodes = currentCodes.find(c => normalize(c.code) === normalize(codeTrimmed));
      if (matchInCodes) {
        codeToRemoveValue = matchInCodes.code;
      } else {
        const matchInApps = applications.find(d => normalize(d.code) === normalize(codeTrimmed) || normalize(d.title) === normalize(codeTrimmed));
        if (matchInApps && matchInApps.code) codeToRemoveValue = matchInApps.code;
        else if (matchInApps && matchInApps.title) codeToRemoveValue = matchInApps.title;
      }

      // Lista de códigos que devem permanecer (todos exceto o que estamos removendo)
      const updatedCodes = currentCodes
        .filter(c => normalize(c.code) !== normalize(codeToRemoveValue))
        .map(c => c.code);

      const discountParam = updatedCodes.length > 0 ? updatedCodes.join(',') : '';

      console.log(PREFIX, 'removeDiscount: código a remover', codeToRemoveValue, '| códigos a manter', updatedCodes, '| body discount', JSON.stringify(discountParam));

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ discount: discountParam })
      });

      const data = await response.json().catch(() => ({}));

      console.log(PREFIX, 'removeDiscount: response.ok', response.ok, 'status', response.status, 'body', data);

      if (response.ok && !data.errors) {
        console.log(PREFIX, 'removeDiscount: sucesso, recarregando carrinho');
        await this.loadCart();
        await this.updateDiscountDisplay();
        return;
      }

      if (data.errors) {
        console.warn(PREFIX, 'removeDiscount: resposta com errors', data.errors);
      }

      // Se a API não aceitar, tentar remover todos enviando string vazia (único código)
      if (applications.length <= 1 && discountParam === '' && !response.ok) {
        console.log(PREFIX, 'removeDiscount: retry com discount: ""');
        const retryRes = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
        const retryData = await retryRes.json().catch(() => ({}));
        console.log(PREFIX, 'removeDiscount: retry response.ok', retryRes.ok, 'body', retryData);
        if (retryRes.ok) {
          await this.loadCart();
          await this.updateDiscountDisplay();
        }
      }
    } catch (err) {
      console.error(PREFIX, 'removeDiscount: erro', err);
    }
  }

  async updateDiscountDisplay() {
    const discountSection = this.drawer?.querySelector('[data-discount-section]');
    if (!discountSection) return;

    const message = discountSection.querySelector('[data-discount-message]');

    // Clear message after 3 seconds
    if (message) {
      setTimeout(() => {
        message.textContent = '';
        message.className = 'custom-cart-discount__message';
      }, 3000);
    }
    
    // Discounts now show in product badges, so we don't need to update the applied container
    return;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.customCartDrawerInstance = new CustomCartDrawer();
  });
} else {
  window.customCartDrawerInstance = new CustomCartDrawer();
}

window.CustomCartDrawer = CustomCartDrawer;
